import { render, staticRenderFns } from "./BaseMultipleItemPicker.vue?vue&type=template&id=8d1eda04&scoped=true"
import script from "./BaseMultipleItemPicker.vue?vue&type=script&lang=js"
export * from "./BaseMultipleItemPicker.vue?vue&type=script&lang=js"
import style0 from "./BaseMultipleItemPicker.vue?vue&type=style&index=0&id=8d1eda04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1eda04",
  null
  
)

export default component.exports